import type { JSX, ReactNode } from 'react'

import { Flex } from '@buffer-mono/popcorn'

import { ChannelFields } from '~publish/components/Composer/components/ChannelFields'

import styles from './YoutubeFieldsView.module.css'

export function YoutubeFieldsView({
  title,
  titleCounter,
  category,
  visibility,
  license,
  notifySubscribers,
  embeddable,
  madeForKids,
}: {
  title: ReactNode
  titleCounter?: ReactNode
  category: ReactNode
  visibility: ReactNode
  license: ReactNode
  notifySubscribers: ReactNode
  embeddable: ReactNode
  madeForKids: ReactNode
}): JSX.Element {
  return (
    <>
      <ChannelFields.Field>
        <ChannelFields.Label>Title</ChannelFields.Label>
        {title}
        {titleCounter}
      </ChannelFields.Field>

      <Flex gap="xs" fullWidth className={styles.selectRow}>
        <ChannelFields.Field className={styles.selectField}>
          <ChannelFields.Label>Category</ChannelFields.Label>
          {category}
        </ChannelFields.Field>
        <ChannelFields.Field className={styles.selectField}>
          <ChannelFields.Label className={styles.visibilityLabel}>
            Visibility
          </ChannelFields.Label>
          {visibility}
        </ChannelFields.Field>
      </Flex>

      <ChannelFields.Field className={styles.selectField}>
        <ChannelFields.Label className={styles.label} size="small">
          License
        </ChannelFields.Label>
        {license}
      </ChannelFields.Field>

      <Flex justify="between" className={styles.checkboxes}>
        <ChannelFields.Field className={styles.checkboxField}>
          {notifySubscribers}
          <ChannelFields.Label className={styles.checkboxLabel}>
            Notify Subscribers
          </ChannelFields.Label>
        </ChannelFields.Field>

        <ChannelFields.Field className={styles.checkboxField}>
          {embeddable}
          <ChannelFields.Label className={styles.checkboxLabel}>
            Allow Embedding
          </ChannelFields.Label>
        </ChannelFields.Field>

        <ChannelFields.Field className={styles.checkboxField}>
          {madeForKids}
          <ChannelFields.Label className={styles.checkboxLabel}>
            Made for Kids
          </ChannelFields.Label>
        </ChannelFields.Field>
      </Flex>
    </>
  )
}
